<template>
  <div>
    <v-select v-model="order" :items="items" item-text="label" solo />
    <div class="d-flex flex-wrap">
      <div v-for="item in sortedList" :key="item.id" class="product-farm-card-list">
        <v-card class="product-farm-card ma-2 pa-2" :class="{selected: harvestId === item.id }"
          @click="()=>clickHandler(item)">
          <div class="pa-2">

            <div class="py-2">
              <span class="product-farm-card-product-info font-weight-bold">{{ $t("product_info") }}</span>
            </div>

            <div class="d-flex justify-end py-1">
              <div>
                <span class="product-farm-card-price"><span class="product-farm-card-price-unit">¥</span>{{ $n(item.sales_price) }}<span
                    class="product-farm-card-price-delivery-fee">（内送料¥{{ $n(item.delivery_fee) }}）</span></span>
              </div>
            </div>
            <div class="d-flex justify-space-between py-2">
              <span class="info-name">{{ $t("stem_size") }}</span>
              <span class="info-value ml-2">
                <strong v-if="item.stem_size_min">{{ item.stem_size_min }} {{ $t("size_label") }}</strong>
              </span>
            </div>
          </div>

          <v-divider />

          <div class="product-farm-card-note px-2 py-3">{{ item.note }}</div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    flowerHarvests: {
      type: Array,
      default: null
    }
  },

  watch: {
    harvestId() {
      this.$emit("input", this.harvestId);
    }
  },

  data() {
    return {
      order: "asc",
      items: [
        { value: "asc", label: this.$t("asc_price"), selected: true },
        { value: "desc", label: this.$t("desc_price") }
      ],
      harvestId: null
    };
  },

  methods: {
    clickHandler(flowerHarvest) {
      this.harvestId = flowerHarvest.id;
    },
    isSalable(flowerHarvest) {
      return flowerHarvest.available_count >= flowerHarvest.min_count;
    }
  },

  computed: {
    sortedList() {
      const list = [...this.flowerHarvests];
      if (this.order === "asc") {
        list.sort((a, b) => a.sales_price - b.sales_price);
      } else {
        list.sort((a, b) => b.sales_price - a.sales_price);
      }

      return list;
    }
  }
};
</script>

<style lang="scss" scoped>
.product-farm-card-list {
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
}

.product-farm-card {
  width: 300px;
  cursor: pointer;

  @media only screen and (max-width: 600px) {
    width: 95%;
  }

  &-face {
    &-img {
      width: 6rem !important;
      height: 6rem !important;

      img {
        object-fit: cover;
      }
    }
  }

  &-farm-info {
    width: 70%;

    .area {
      .label {
        width: 3.5rem;
      }

      &-name {
        text-align: center;
        flex: 1;
      }
    }
  }

  &-farm {
    font-weight: bold;
    font-size: 20px;
    color: #424242;
  }

  &-price {
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    color: #ff8c71;
    overflow-wrap: anywhere;

    &-unit {
      font-weight: bold;
      font-size: 18px;
      line-height: 22px;
    }

    &-delivery-fee {
      font-size: 14px;
      line-height: 17px;
    }
  }

  &-note {
    max-height: 100px;
    overflow: auto;
  }

  .info-name {
    width: 45%;
  }

  .info-value {
    text-align: right;
    width: 55%;
  }
}

.selected {
  background: #ffffff;
  border: 4px solid #00796b;
  box-sizing: border-box;
  border-radius: 8px;
}

.disabled {
  background: rgba(31, 31, 31, 0.47);
}
</style>
